<template>
  <div class="coupon__list">
    <SlideWrap v-if="list.length" :style="style">
      <CouponItem
        @click="getDiscount(coupon.couponId)"
        v-for="coupon in list"
        :key="coupon.couponId"
        :coupon="coupon"
      />
    </SlideWrap>
  </div>
</template>

<script>
import * as api from '@/services';
import SlideWrap from '@/components/SlideWrap';
import CouponItem from './CouponItem';
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    SlideWrap,
    CouponItem
  },
  data() {
    return {
      style: {
        padding: '16px 52px'
      }
    };
  },
  methods: {
    async getDiscount(couponId) {
      try {
        const data = await api.coupon.getCouponById({ couponId });
        if (!data) {
          this.$message.success('领取成功');
        }
      } catch (error) {}
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon__list {
  position: relative;
  display: flex;
  margin-top: 16px;
  height: 172px;
  background: #ffffff;
}
</style>
